import { defineStore } from 'pinia';
import { inject } from 'vue';
import API from "@/classes/API";
import ErrorHandler from "@/classes/ErrorHandler";
import type { User_UserObject } from "@/types/user";

export const useAuthStore = defineStore('auth', {
	state: () => ({
		apiInstance: inject('apiInstance') as API,
		user: null as User_UserObject | null,
	}),
	getters: {
		isLoggedIn: (state) => !!state.user,
		getUser: (state) => state.user
	},
	actions: {
		async fetchUser() {
			// getUser() non rigetta mai: in caso di errore o timeout ritorna null,
			// che qui equivale a utente non autenticato.
			this.user = await this.apiInstance.getUser();
			ErrorHandler.setUser(this.user?.Id);
		},
		logout() {
			this.user = null;
			ErrorHandler.setUser(null);
		}
	}
});
